import http from "@/plugins/Axios";

export default {
  actions: {
    async getDepartments(_, query) {
      try {
        let {
          data: { data, total },
        } = await http.get("deparments", {
          params: {
            page: query && query.page && query.page,
            limit: query && query.limit,
            name: query && query.name,
          },
        });
        return {
          data,
          lastPage: query && query ? Math.ceil(total / query.limit) : null,
          total,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
